const projects = [
  { slug: "dubai-fashion-week", name: "Dubai Fashion Week (DFW)" },
  { slug: "eze-logs", name: "Ezelog" },
  { slug: "shl-london", name: "SHL London" },
  { slug: "bright-vision-health", name: "Bright Vision Health" }
  // add more projects here...
];

export default projects;